
export let timeLine = [
    {
        "year": "2022.02",
        "compishment": "癫痫致痫灶精准定位系统在三博医院、天坛医院和宣武医院开始试用。",
    },
    {
        "year": "2021.11",
        "compishment": "深度参与中国科学技术大学合肥综合性国家科学中心人工智能研究院癫痫无创精准定位方向的建设工作。",
    },
    {
        "year": "2021.10",
        "compishment": "作为课题承担单位，荣获北京市“AI+健康协同创新培育”专项课题支持。",
    },
    {
        "year": "2021.09",
        "compishment": "作为课题参与单位，参与四项科技创新2030—“脑科学与类脑研究”重大项目。",
    },
    {
        "year": "2021.05",
        "compishment": "NeuroScholar平台部署在北京脑科学与类脑研究中心、北京大学、香港理工大学、华东师范大学等国内顶尖科研机构，一线参与脑科学领域新方法的开发应用，实现了产品的持续迭代和平稳运行。",
    },
    {
        "year": "2021.01",
        "compishment": "公司实施全方位知识产权布局，已获得五项发明专利，九项软件著作权，另有六项发明专利进入实质审核阶段。",
    },
    {
        "year": "2020.10",
        "compishment": "NeuroScholar产品获得欧盟CE 医疗器械2类认证。",
    },
    {
        "year": "2020.07",
        "compishment": "NeuroScholar平台部署在北京宣武医院、上海同济医院、华西医院、郑州大学第一附属医院、深圳康宁医院等全国知名三甲医院，与顶级临床机构建立了深度合作。",
    },
    {
        "year": "2020.01",
        "compishment": "在研产品癫痫致痫灶精准定位系统InsightEpilepsy获得突破性进展",
    },
    {
        "year": "2019.12",
        "compishment": "公司上榜中国数字医疗榜100强企业",
    },
    {
        "year": "2019.11",
        "compishment": "公司获得国家高新技术企业认定",
    },
    // {
    //     "year": "2019.10",
    //     "compishment": "南京慧脑云脑科学研究院正式揭牌",
    // },
    // {
    //     "year": "2019.10",
    //     "compishment": "公司与北京大学联合成立协同创新实验室",
    // },
    {
        "year": "2019.08",
        "compishment": "公司完成A轮五千万人民币融资",
    },
    {
        "year": "2019.01",
        "compishment": "慧脑云成立并完成千万级人民币天使轮融资",
    },
]